export enum Role {
    NONE_TO_MANY = 7,
    NONE_TO_ONE = 9,
    ONE_OF_MANY = 11,
}
